















import {Component} from "vue-property-decorator";
import {UserLevel} from "shared/entities/user";
import TrainingSection from "@/components/training-section.vue";
import BrandManualSection from "@/components/brand-manual-section.vue";
import ManagementSection from "@/components/managment-section.vue";
import {mixins} from "vue-class-component";
import AuthMixin from "@/mixins/auth.mixin";

@Component({
    components: {ManagementSection, BrandManualSection, TrainingSection},
})
export default class Home extends mixins(AuthMixin) {
    UserLevel = UserLevel;
}

